
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

Swiper.use([Navigation, Pagination, Autoplay])

export const HotelCarouselSlider = () => {
  // const $sliderWrapper = $('.js-heroSlider__imageSliderWrapper');
  // if ( !$sliderWrapper.length ) {
  //   return
  // }

  $(document).ready(function() {

    $('.c-hotel-carousel').each(function () {
      const mainSliderEl = $(this).find('.js-hotel-carousel');
      const paginationContainer = $(this).find('.c-hotel-carousel__pagination');
      const paginationPrev = $(this).find('.c-hotel-carousel__prevSlide');
      const paginationNext = $(this).find('.c-hotel-carousel__nextSlide');

      const modalSliderEl = $(this).find('.js-hotel-carousel-modal');
      const modalPaginationPrev = $(this).find('.js-hotel-carousel-modal__prevSlide');
      const modalPaginationNext = $(this).find('.js-hotel-carousel-modal__nextSlide');

      const mainSlider = new Swiper(mainSliderEl, {
        effect: 'slide',
        autoplay: {
          delay: 4000,
        },
        speed: 600,
        pagination: {
          el: paginationContainer,
          clickable: true,
          renderBullet: function (index, className) {
            return (
              `<span class="c-heroSlider__paginationItem ${className}">
              <span></span>
              <span>${index + 1}</span>
            </span>`
            )
          },
        },
        navigation: {
          nextEl: paginationNext,
          prevEl: paginationPrev,
        },
      });

      const modalSlider = new Swiper(modalSliderEl, {
        effect: 'slide',
        calculateHeight: true,
        slidesPerView: 'auto',
        direction: 'vertical',
        spaceBetween: 20,

        breakpoints: {
          992: {
            slidesPerView: 1,
            direction: 'horizontal',
            spaceBetween: 0,
          },
        },

        navigation: {
          nextEl: modalPaginationNext,
          prevEl: modalPaginationPrev,
        },
      });


      mainSlider.controller.control = modalSlider;
      modalSlider.controller.control = mainSlider;

      $('.js-hotel-carousel-modal--wrapper').each(function() {
        $(this).on('shown.bs.modal', function () {
          modalSlider.update();
          mainSlider.autoplay.stop();
        })
      })

    });

  });
}
